import { render, staticRenderFns } from "./CanNotPayModal.vue?vue&type=template&id=270bd2de&scoped=true"
import script from "./CanNotPayModal.vue?vue&type=script&lang=js"
export * from "./CanNotPayModal.vue?vue&type=script&lang=js"
import style0 from "./CanNotPayModal.vue?vue&type=style&index=0&id=270bd2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270bd2de",
  null
  
)

export default component.exports